import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setOverlayNotice } from '../../features/settingSlice'
import { ReactComponent as Close } from "../../assets/new-icons/close.svg";
import { ReactComponent as Alert } from "../../assets/new-icons/alert.svg";
import axios from 'axios'
import md5 from 'md5'
import { getPopupInfo } from '../../features/popupSlice';
import { getInfoPopupGas, setPopOff } from '../../features/gasSlice'

function AlertNotice({seeClose = false, title, paragraphOne, paragraphTwo, shooFooter = false}) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const selectorUser = useSelector((user) => user.user)
    const email = selectorUser.info && selectorUser.info.user_email;
    const customerId = selectorUser.info.customer_id;
    const tkn = md5(customerId + "oYmAIdtki%lu");
    const popupPara = useSelector(getPopupInfo)
    const popupParaGas = useSelector(getInfoPopupGas)
    const section = useSelector((user) => user.settings.section)
    

    const handleChecked = async () => {
        const url = `https://my.revoluce.it/area_utente/gestione/api/customers/setFlagPopup.php?customer_id=${customerId}&tkn_pvt=${tkn}&email=${email}`;
        const { data } = await axios.get(url);
    };
    return (
        <div className="notice">
            <div className="close" style={seeClose ? { display: 'none' } : null}>
                <Close onClick={() => section ? dispatch(setPopOff(false)) : dispatch(setOverlayNotice(false))} />
            </div>
            <div className="box">
                <div className="header">
                    <Alert />
                    <p>{section ? popupParaGas.titolo_popup : popupPara.titolo_popup}</p>
                </div>
                <div className="body">
                    <p>
                    {section ? popupParaGas.body_popup : popupPara.body_popup}
                    </p>
                </div>
                <div className="footer" style={shooFooter ? {display: 'none'} : null}>
                    {/* <div className="checkbox">
                        <input
                            type="checkbox"
                            name="check"
                            id=""
                            onChange={() => handleChecked()}
                        />{" "}
                        <label htmlFor="check">Non visualizzare più</label>
                    </div> */}
                    {
                        section ? (
                        
                            <div
                                className="approfondisci"
                                onClick={() => navigate(`/enrica/gas/rinnovo-contrattuale`)}
                            >
                                <p>Scopri i dettagli gas</p>
                                <ArrowForwardIos />
                            </div>
                        ) : (
                            popupPara.btn_popup ? (
                                <div
                                    className="approfondisci"
                                    onClick={() => navigate(`${popupPara.link_popup}`)}
                                >
                                    <p>Scopri i dettagli 1</p>
                                    <ArrowForwardIos />
                                </div>
                            ) : null
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default AlertNotice